<template>
  <div v-if="is_buy==1 && msg !== ''">
    <p class="center fixed isbuymsg">{{ msg }}</p>
  </div>
  <div class="detail-tabbar fixed r l" v-if="is_buy===1 && sales_method === 1">

    <div class="flex between size12 C888">
      <div class="detail-tabbar-l flex">
        <div @click="handleTs">
          <img src="@/assets/img/icon16-1.png" />
          <p class="size12">投诉</p>
        </div>
        <div class="detail-tabbar-l-mid" @click="handleCollect">
          <img :src="isCollect === 1?require('@/assets/img/icon26-1.png'):require('@/assets/img/icon26.png')" />
          <p class="size12" :class="{'active': (isCollect === 1)}">收藏</p>
        </div>
        <div @click="handleKf">
          <img src="@/assets/img/icon18.png" />
          <p class="size12">客服</p>
        </div>
      </div>
      <div class="detail-tabbar-r flex">
        <button @click="handleJg">加购</button>
        <button @click="handleZf">支付</button>
      </div>
    </div>
  </div>
  <p class="center tabartip fixed r l" v-if="is_buy===0 && sales_method === 1">{{ msg }}</p>
  <div class="detail-tabbar fixed r l" v-if="sales_method === 2">

  <div class="flex between size12 C888">
    <div class="detail-tabbar-l flex">
      <div @click="handleTs">
        <img src="@/assets/img/icon16-1.png" />
        <p class="size12">投诉</p>
      </div>
      <div class="detail-tabbar-l-mid" @click="handleCollect">
        <img :src="isCollect === 1?require('@/assets/img/icon26-1.png'):require('@/assets/img/icon26.png')" />
        <p class="size12" :class="{'active': (isCollect === 1)}">收藏</p>
      </div>
      <div @click="handleKf">
        <img src="@/assets/img/icon18.png" />
        <p class="size12">客服</p>
      </div>
    </div>
    <div class="detail-tabbar-r flex">
      <button @click="handleOrder" >发起订单</button>
    </div>
  </div>
  </div>
</template>
<script>
import ajax from "@/utils/request.js";
import { showToast, showConfirmDialog } from "vant";
export default {
  data () {
    return {}
  },
  props: {
    is_buy: {
      type: Number,
      default: 0
    },
    msg: {
      type: String,
      default: ""
    },
    goods_id: {
      type: Number
    },
    isCollect: {
      type: Number,
      default: 0
    },
    is_concept: {
      type: Number,
      default: 0
    },
    sales_method: {
      type: Number,
      default: 1
    }
  },
  emits: ['handleZf', 'handleJg', 'handleCollect'],
  methods: {
    // 发起订单
    handleOrder(){
      this.$router.push({ path: '/shop/order/custom', query: { goods_id: this.goods_id} })
       

    },
    handleZf () {
      if (this.is_concept === 0) {
        this.$router.push({ path: '/shop/sense', query: { cate_id: 0 } })
        return
      }
      this.$emit('handleZf', true)
    },
    handleJg () {
      if (this.is_concept === 0) {
        this.$router.push({ path: '/shop/sense', query: { cate_id: 0 } })
        return
      }
      this.$emit('handleJg', true)
    },
    handleTs () {
      if (!localStorage.getItem('loginInfo')) {
        showConfirmDialog({
          title: '是否登录'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: "/login" })
          }).catch(() => {
            return false
          });

      } else {

        this.$router.push({ path: '/shop/feedback', query: { title: '投诉', goods_id: this.goods_id, type: 1 } })

      }
    },
    handleKf () {

      if (!localStorage.getItem('loginInfo')) {
        showConfirmDialog({
          title: '是否登录'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: "/login" })
          }).catch(() => {
            return false
          });

      } else {
        if (this.is_concept === 0) {
          // showToast({
          //   message: '观念不匹配',
          // })
          this.$router.push({ path: '/shop/sense', query: { cate_id: 0 } })
          return
        }
        this.$router.push({ path: '/shop/feedback', query: { title: '客服', goods_id: this.goods_id, type: 2 } })
      }
    },
    handleCollect () {
      // products/collect
      const collect = this.isCollect === 0 ? 1 : 2;
      const data = {
        typeid: collect,
        id: this.goods_id
      }
      ajax.post("products/collect", data).then(res => {
        if (res.errcode === 1) {
          const val = this.isCollect === 0 ? 1 : 0
          this.$emit('handleCollect', val)
          showToast(res.message)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.active {
  color: #3F7C93;
}
.detail-tabbar {
  bottom: 0;
  padding: 2.4vw 4vw 3.2vw 5.6vw;
  box-shadow: 0px -1px 20px 0px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  z-index: 99;
  .detail-tabbar-l {
    img {
      display: block;
      width: 5.3333vw;
      margin: 0 auto;
    }
    .detail-tabbar-l-mid {
        margin-left: 6.4vw;
        margin-right: 6.4vw;
    }
    p {
        text-align: center;
    }
  }
  .detail-tabbar-r {
    justify-content: flex-end;
    button {
      border-radius: 6vw;
      font-size: 14px;
      padding: 2.6667vw 8vw;
      box-sizing: border-box;
      &:first-child {
        border: 3px solid #E30000;
        color: #E30000;
        background-color: #fff;
      }
      &:last-child {
        border: 3px solid #E30000;
        background-color: #E30000;
        color: #fff;
        margin-left: 2.6667vw;
      }
    }
  }
}
.tabartip {
    bottom: 0;
    height: 42px;
    line-height: 42px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    font-size: 14px;
    z-index: 99;
  }
  .isbuymsg {
    left: 0;
    right: 0;
    bottom: 64px;
    height: 42px;
    line-height: 42px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    font-size: 14px;
  }
</style>